import React from "react";
import {
  DialogProps,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Body1,
  DialogActions,
  DialogTrigger,
  Button,
} from "@fluentui/react-components";

import { ClauseData } from "@/types/risk-analysis";

export interface ExitPlaybookRuleEditorDialogProps extends Omit<DialogProps, "children"> {
  playbookRule?: ClauseData;
  onAccept: () => void;
}

export function ExitPlaybookRuleEditorDialog({ playbookRule, onAccept, ...props }: ExitPlaybookRuleEditorDialogProps) {
  return (
    <Dialog {...props}>
      <DialogSurface
        aria-labelledby={`exit-${playbookRule?.id}-title`}
        aria-describedby={`exit-${playbookRule?.id}-content`}
      >
        <DialogBody>
          <DialogTitle id={`exit-${playbookRule?.id}-title`}>Confirm exit</DialogTitle>
          <DialogContent id={`exit-${playbookRule?.id}-content`}>
            <Body1>
              Are you sure you want to exit the editor? You have unsaved changes for the “
              <b>{playbookRule?.clauseTopic || "Untitled"}</b>” playbook rule.
            </Body1>
            <br />
            <Body1>If you exit now your unsaved changes will be lost.</Body1>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={onAccept}>
              Exit
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
